module.exports = __webpack_public_path__ + "img/libra.fa2c9afb.svg";